import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import RhService from '../../../../services/rh';


const FormCadRH = () => {
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [nivel, setNivel] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const rh = await RhService.cadastro({
                nome: nome,
                email: email,
                senha: senha,
                nivel: nivel
            })
            if (rh.data["_id"]) {
                setSucesso(true);
            }
            else {
                alert(rh.data["error"]);
            }
        } catch (error) {
            setError("Deu algo errado no seu cadastro!")
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setEmail("");
        setSenha("");
        setNivel("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={1}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={1} lg={2}>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="nome">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="nome"
                                            value={nome}
                                            onChange={e => setNome(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group controlId="selectNivel">
                                        <Form.Label>Nível</Form.Label>
                                        <Form.Select required value={nivel} onChange={e => setNivel(e.target.value)}>
                                            <option value="">SELECIONE</option>
                                            <option value="Administradora">Administradora</option>
                                            <option value="Funcionária">Funcionária</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="Email">
                                        <Form.Label>E-mail</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="senha">
                                        <Form.Label>Senha</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="senha"
                                            value={senha}
                                            onChange={e => setSenha(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={3}>
                                    <Button variant="success" type="submit">
                                        Cadastrar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >
                    </Row>
                    <br />
                    <Link to={'/rh/rh'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>Usuária cadastrada com sucesso!</Alert>
                    <Button onClick={addNovo} variant="success" type="submit">
                        Adicionar outro
                    </Button>
                    <br /><br />
                    <Link to={'/rh/rh/listar'}>
                        <Button variant="primary" type="button">
                            Ir para Listagem de Usuários
                        </Button>
                    </Link>
                    <br /><br />
                    <Link to={'/rh/rh'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Container>
            </Fragment>
        )
    }
}

export default FormCadRH;